import { Reveal } from "@/components/Reveal";
import { CtaPair } from "@/components/CtaButtons";

const FEATURES = [
  {
    title: "ER Clarity Session",
    desc: "For senior HR professionals who need an independent second opinion on a complex employee relations matter — a focused, confidential conversation to pressure-test your thinking.",
    to: "/employee-relations-advisory",
    reason: "Other Employee Relations Matter",
    key: "clarity",
  },
  {
    title: "Sensitive Case Advisory",
    desc: "Senior advisory support for complex, high-risk, sensitive or time-critical employee matters — from case strategy and governance through to resolution.",
    to: "/sensitive-case-advisory",
    reason: "Complex / Sensitive ER Case",
    key: "sensitive",
  },
];

const TOPICS = [
  "Workplace investigations", "Misconduct", "Harassment & bullying", "Discrimination", "Retaliation",
  "Grievances", "Disciplinary matters", "Conduct issues", "Complex performance", "Senior-employee cases",
  "Sensitive exits", "Investigation strategy", "Case governance", "Escalation decisions", "People-risk assessment",
];

export function CaseJourney() {
  return (
    <section id="case" data-testid="case-journey-section" className="py-28 px-6 md:px-12 bg-ink">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <p className="font-mono text-[11px] tracking-[0.35em] text-gold uppercase mb-6">Need help with a case now?</p>
          <h2 className="font-serif font-light text-4xl md:text-6xl tracking-tight max-w-3xl mb-6">
            Need an independent perspective on a complex ER matter?
          </h2>
          <p className="text-muted2 max-w-2xl leading-relaxed mb-16">
            Senior HR professionals sometimes need an experienced, confidential and independent perspective before
            making decisions on sensitive employee matters. That is exactly what this is for.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
          {FEATURES.map((f, i) => (
            <Reveal key={f.key} delay={i * 0.06}>
              <div data-testid={`case-feature-${f.key}`} className="border border-white/12 hover:border-gold/40 transition-colors duration-300 p-8 md:p-10 h-full flex flex-col">
                <h3 className="font-serif text-2xl md:text-3xl font-light mb-4">{f.title}</h3>
                <p className="text-muted2 leading-relaxed flex-1 mb-8">{f.desc}</p>
                <CtaPair serviceTo={f.to} serviceLabel="Explore" reason={f.reason}
                  serviceTestid={`case-explore-${f.key}`} bookTestid={`case-book-${f.key}`} />
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-muted2 mb-5">Matters I regularly advise on</p>
          <div className="flex flex-wrap gap-2.5">
            {TOPICS.map((t) => (
              <span key={t} className="font-sans text-xs tracking-wide text-bone/80 border border-white/12 rounded-full px-4 py-2">{t}</span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
